import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { supabase } from '@/integrations/supabase/client';
import { Button } from '@/components/ui/button';
import { X, Gift, ArrowRight } from 'lucide-react';
import { isAndroidTWA } from '@/utils/runtimeContext';

const FreeUserOfferBanner = () => {
  const { user, isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const [showBanner, setShowBanner] = useState(false);
  const inTWA = isAndroidTWA();

  useEffect(() => {
    if (!isAuthenticated || !user) {
      setShowBanner(false);
      return;
    }

    // Só mostra para usuários free não assinantes
    if (user.plan !== 'free' || user.isSubscribed) {
      setShowBanner(false);
      return;
    }

    // Verifica se o usuário dispensou nas últimas 48h
    const dismissedTime = localStorage.getItem('free-offer-dismissed-time');
    if (dismissedTime) {
      const hoursSinceDismissed = (Date.now() - parseInt(dismissedTime)) / (1000 * 60 * 60);
      if (hoursSinceDismissed < 48) {
        setShowBanner(false);
        return;
      }
    }

    // Busca created_at do profile para verificar 3 dias
    const checkCreatedAt = async () => {
      const { data } = await supabase
        .from('profiles')
        .select('created_at')
        .eq('id', user.id)
        .single();

      if (data?.created_at) {
        const daysSinceCreation = (Date.now() - new Date(data.created_at).getTime()) / (1000 * 60 * 60 * 24);
        if (daysSinceCreation >= 3) {
          setShowBanner(true);
        }
      }
    };

    checkCreatedAt();
  }, [user, isAuthenticated]);

  const handleDismiss = () => {
    localStorage.setItem('free-offer-dismissed-time', Date.now().toString());
    setShowBanner(false);
  };

  const handleGoToPlans = () => {
    navigate('/planos');
  };

  if (inTWA || !showBanner) return null;

  return (
    <div className="w-full bg-gradient-to-r from-amber-500 via-orange-500 to-red-500 text-white py-3 px-4 relative z-40">
      <div className="max-w-6xl mx-auto flex items-center justify-between gap-3">
        <div className="flex items-center gap-3 flex-1 min-w-0">
          <Gift className="h-5 w-5 flex-shrink-0 animate-pulse" />
          <p className="text-sm font-medium truncate">
            🔥 <strong>Oferta especial!</strong> Assine agora com <strong>20% de desconto</strong> no primeiro mês! Use o código <strong>GURU20</strong>
          </p>
        </div>
        <div className="flex items-center gap-2 flex-shrink-0">
          <Button
            onClick={handleGoToPlans}
            size="sm"
            className="bg-white text-orange-600 hover:bg-white/90 font-bold text-xs"
          >
            Ver Planos <ArrowRight className="h-3 w-3 ml-1" />
          </Button>
          <Button
            variant="ghost"
            size="icon"
            onClick={handleDismiss}
            className="text-white hover:bg-white/20 h-7 w-7"
          >
            <X className="h-4 w-4" />
          </Button>
        </div>
      </div>
    </div>
  );
};

export default FreeUserOfferBanner;
